export default [
  {
    path: '/notifications',
    name: 'NotificationsPage',
    component: () => import('../pages/NotificationsPage.vue'),
  },
];
